var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogPostEditModalIcon = function SvgBlogPostEditModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#F0B51A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.17 23.137-.003.004-.001.001-.002.001-.001.001a.065.065 0 0 1-.014.005l-3.406.597a.522.522 0 0 1-.606-.603l.598-3.408a.04.04 0 0 1 .011-.022l8.594-8.593-.117-.117.117.117a.036.036 0 0 1 .027-.01c.013 0 .021.003.028.01l3.369 3.371a.038.038 0 0 1 .011.026.037.037 0 0 1-.01.027h-.001l-8.593 8.593Zm-2.272-2.87-.037.037-.009.05-.316 1.805-.04.232.231-.041 1.802-.319.051-.009.037-.036 7.353-7.351.116-.117-.116-.116-1.486-1.486-.117-.117-.116.117-7.353 7.35Zm-3.555 5.52h14.92c.268 0 .485.215.485.483v.727H10.859v-.727c0-.268.216-.484.484-.484Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.33
  })));
};
export default SvgBlogPostEditModalIcon;